export default {
      id: "ic_clear-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_clear",
      toString: function () {
        return this.url;
      }
    }